/**
 * Customer (receiver) as first-class entity. Reused across invoices; audit by referencing id.
 * When creating an invoice, copy customer data into the invoice as a receiver snapshot.
 */
/** RUT used when the receiver is final consumer (e.g. e-Ticket 101 without client RUT). DGI convention. */
export const CONSUMER_PLACEHOLDER_RUT = '000000000000';
/** Name used when the receiver is final consumer. */
export const CONSUMER_PLACEHOLDER_NAME = 'Consumidor final';
/** True when the receiver snapshot represents final consumer (no tax ID required). */
export function isConsumerFinalReceiver(rut) {
    return rut === CONSUMER_PLACEHOLDER_RUT;
}
